import BaseService from "scripts/services/baseService";

class WebDeviceService extends BaseService {
  get platform() {
    return "WEB";
  }
}

export default WebDeviceService;
